
import clamp from 'lodash/clamp'
import { getPointerClientPosition } from '~/utils/get-pointer-client-position'

const availableImageSizes = [600, 400, 200, 100]

export default {
  props: {
    src: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
    defaultWidth: {
      type: Number,
      default: 400,
    },
    zoomWidth: {
      type: Number,
      default: 600,
    },
    sizes: {
      type: String,
      default: '163px',
    },
    availableImageSizes: {
      type: Array,
      default: () => availableImageSizes,
    },
  },
  data() {
    return {
      error: false,
      lightboxVisible: false,
      zoomVisible: false,
      zoomScale: 1,
      zoomTranslate: [0, 0],
    }
  },
  computed: {
    srcSet() {
      const pngs = this.availableImageSizes.map(
        (size) => `${this.getUrl({ w: size, fm: 'png8' })} ${size}w`,
      )

      const webp = this.availableImageSizes.map(
        (size) => `${this.getUrl({ w: size, fm: 'webp' })} ${size}w`,
      )

      return [...webp, ...pngs].join(',')
    },
    scaledSrc() {
      return this.getUrl({ w: this.defaultWidth })
    },
    zoomSrc() {
      return this.getUrl({
        w: this.availableImageSizes[0],
      })
    },

    zoomStyle() {
      return {
        width: `${this.zoomScale * 100}%`,
        height: `${this.zoomScale * 100}%`,
        transform: `translate(${this.zoomTranslate[0]}, ${this.zoomTranslate[1]})`,
      }
    },
  },
  methods: {
    getUrl(props) {
      const params = new URLSearchParams(props)
      return this.src + '?' + params.toString()
    },
    handleZoom(event) {
      const [clientX, clientY] = getPointerClientPosition(event)

      const boundingRect = event.currentTarget.getBoundingClientRect()
      const scale = Math.max(1, this.zoomWidth / boundingRect.width)

      const x = clientX - boundingRect.left
      const y = clientY - boundingRect.top

      const dx = clamp(x / boundingRect.width, 0, 1)
      const dy = clamp(y / boundingRect.height, 0, 1)

      const tx = ((dx * (1 - scale)) / scale) * 100
      const ty = ((dy * (1 - scale)) / scale) * 100

      this.zoomVisible = true
      this.zoomScale = scale
      this.zoomTranslate = [`${tx}%`, `${ty}%`]
    },
    hideZoom(event) {
      this.zoomVisible = false
    },
  },
}
